import React from 'react';

// Se renderiza cuando /config.js falta o es inválida. Sin dependencias a
// propósito: tiene que funcionar justo cuando nada más funciona.
function ConfigError({ message }) {
    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6 font-sans">
            <div className="w-full max-w-lg bg-white rounded-3xl shadow-xl p-8 border border-slate-100 text-center">
                <h1 className="text-2xl font-black text-slate-800 mb-3">
                    Error de configuración
                </h1>
                <p className="text-slate-500 mb-6">
                    Esta sucursal virtual no pudo cargar su configuración, así que no
                    se inició para evitar mostrar datos equivocados.
                </p>
                {message && (
                    <p className="font-mono text-sm bg-slate-100 text-slate-700 rounded-xl px-4 py-3 mb-6 break-words">
                        {message}
                    </p>
                )}
                <p className="text-sm text-slate-400">
                    Avisa al equipo que administra este sitio.
                </p>
            </div>
        </div>
    );
}

export default ConfigError;
